import React from "react";
import Layout from "./src/container/Layout";
import * as bootstrap from "@styled-icons/bootstrap";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import SessionSuccess from "./src/container/SessionSuccess";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
  },
  {
    path: "/success",
    element: <SessionSuccess />,
  },
]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
